"use strict"

let previousVerticalPos = 0

const isInViewport = (el) => {
	const rect = el.getBoundingClientRect();
	const vWidth = window.innerWidth || document.documentElement.clientWidth;
	const vHeight = window.innerHeight || document.documentElement.clientHeight;
	const efp = (x, y) => {
		return document.elementFromPoint(x, y);
	}
	// Return false if it's not in the viewport
	if (rect.right < 0 || rect.bottom < 0 || rect.left > vWidth || rect.top > vHeight) return false;
	// Return true if any of its four corners are visible
	return (
		el.contains(efp(rect.left, rect.top))
		|| el.contains(efp(rect.right, rect.top))
		|| el.contains(efp(rect.right, rect.bottom))
		|| el.contains(efp(rect.left, rect.bottom))
	);
}

const isSp = () => {
	//Humberger
	const $navbarBurgers = Array.prototype.slice.call(document.querySelectorAll("button.main-nav__humberger"), 0);
	const humberger = window.getComputedStyle($navbarBurgers[0])["display"];
	if (humberger === "none") {
		return false;
	} else {
		return true;
	}
}

// const addClassInView = (el) => {
// 	el.forEach(el => {
// 		if (isInViewport(el)) {
// 			el.classList.add("top_anime_show")
// 			// console.log(el)
// 		}
// 	})
// }

const checkOnScroll = () => {
	//Frame in anime
	// const fiAnime = Array.prototype.slice.call(document.querySelectorAll(".top_anime_fi"),0)
	// if (fiAnime!==undefined) addClassInView(fiAnime)

	//Floating navi
	const $mainNav = document.querySelectorAll(".main-nav__list")[0];
	const $floating = document.querySelectorAll(".footer__floating")[0];
	if ($mainNav !== undefined) {
		if (isInViewport($mainNav)) {
			$floating.classList.remove("fadein");
		} else {
			$floating.classList.add("fadein");
		}
	}

	const currentVerticalPos = window.pageYOffset || document.documentElement.scrollTop
	const $body = document.querySelectorAll("body")[0];
	const $header = document.getElementById("header");
	const $main = document.querySelectorAll("main")[0];
	const removeSpace = () => {
		$main.style.paddingTop = `0`;
		$body.classList.remove("fixed");
	}
	if (!isSp()) {
		if ($body !== undefined && $header !== undefined && $main !== undefined) {
			if (previousVerticalPos < currentVerticalPos) {
				removeSpace();
			} else {
				const headerHeight = $header.clientHeight;
				$main.style.paddingTop = `${headerHeight}px`;
				$body.classList.add("fixed");
			}
			if (previousVerticalPos === currentVerticalPos || currentVerticalPos <= 0) {
				removeSpace();
			}
		}
	} else {
		removeSpace();
	}
	previousVerticalPos = currentVerticalPos
}

window.addEventListener("scroll", () => {
	checkOnScroll();
})

const getPictureOfTheWeek = () => {
	const day = ["日", "月", "火", "水", "木", "金", "土"];
	const loc = location;
	const jsonPath = `${loc.protocol}//${loc.hostname}/themes/asu/common/weekly/`;

	//get Today
	const today = new Date()//new Date(2022,10,4)
	const cnvToday = getSpecificDate(today);
	const cnvTodayDate = cnvToday["dy"];
	if (cnvTodayDate > 0) {
		const cnvTodayDate = cnvTodayDate;
	} else {
		const cnvTodayDate = 0;
	}
	//get nearest sunday
	const thisSunday = getSpecificDate(new Date(cnvToday["y"], cnvToday["m"], cnvToday["d"] - cnvTodayDate));
	const thisSundayStr = `${thisSunday["y"]}年${thisSunday["m"] + 1}月${thisSunday["d"]}日（${day[thisSunday["dy"]]}）`;
	// console.log(`nearest sunday: ${thisSundayStr}`);

	//get the day of Jun.1st
	const firstDay = new Date(cnvToday["y"], 0, 1);
	const cnvFirstDay = getSpecificDate(firstDay);
	const cnvFirstDate = cnvFirstDay["dy"];

	//get the first sunday
	let diffday = 0;
	if (cnvFirstDate > 0) {
		diffday = Math.abs(7 - cnvFirstDate);
	}
	const firstSunday = getSpecificDate(new Date(cnvToday["y"], 0, 1 + diffday));

	//get all sundays
	const sundays = []
	for (let n = 0; n <= 51; n++) {
		const ndate = getSpecificDate(new Date(firstSunday["y"], firstSunday["m"], firstSunday["d"] + n * 7));
		if (ndate["y"] === firstSunday["y"]) {
			sundays.push(`${ndate["y"]}年${ndate["m"] + 1}月${ndate["d"]}日（${day[ndate["dy"]]}）`);
		}
	}

	let sundayIdx = sundays.findIndex(e => e === thisSundayStr);
	if (sundayIdx < 0) {
		sundayIdx = 0;
	}
	// console.log(sundays)
	// console.log(`${sundayIdx} / ${sundays[sundayIdx]}`)

	const place = document.getElementById("weekly")
	if (place !== null) {
		const request = new XMLHttpRequest();
		request.open("GET", `${jsonPath}weekly.json`, true);
		request.onload = function () {
			if (request.status >= 200 && request.status < 400) {
				// Success!
				const data = JSON.parse(request.responseText);
				const nowImg = `${jsonPath}${data[sundayIdx].image}.jpg`;
				place.style.backgroundImage = `url(${nowImg})`;
				// const weeklyImg = new Image()
				// weeklyImg.src = nowImg
				// document.body.append(weeklyImg)
			} else {
				// We reached our target server, but it returned an error
			}
		}
		request.onerror = function () {
			// There was a connection error of some sort
		}
		request.send()
		// return sundayIdx
	}
}

const getSpecificDate = (obj) => {
	if (typeof obj.getDate === "function") {
		const cnvToday = obj;
		const tYear = cnvToday.getFullYear();
		const tMonth = cnvToday.getMonth();
		const tDate = cnvToday.getDate();
		const tDay = cnvToday.getDay();
		return {
			"y": tYear,
			"m": tMonth,
			"d": tDate,
			"dy": tDay
		}
	}
}

const setMonthly = () => {
	const coverMonthly = document.getElementById("monthly");
	if (coverMonthly !== null) {
		const today = new Date();
		const todayMonth = today.getMonth();
		const month = [
			"jan",
			"feb",
			"mar",
			"apr",
			"may",
			"jun",
			"jul",
			"aug",
			"sep",
			"oct",
			"nov",
			"dec"
		]
		const loc = location;
		const port = (loc.port!="")?`:${loc.port}`:"";
		const imgPath = `${loc.protocol}${port}//${loc.hostname}/themes/asu/common/monthly/${month[todayMonth]}.jpg`;
		coverMonthly.setAttribute("src", imgPath);
		// console.log(todayMonth)
	}
}

document.addEventListener("DOMContentLoaded", () => {

	//ナビゲーション
	const $mainNav = Array.prototype.slice.call(document.querySelectorAll(".main-nav__list"), 0);
	if ($mainNav.length > 0) {
		const $navSearch = document.getElementById("nav_search");
		if ($navSearch !== null) {
			$navSearch.classList.add("has-child", "nav_level_1", "search__form");
			const $navSearchForm = document.querySelectorAll(".main-nav__search")[0].cloneNode(true);
			// $navSearchForm.classList.add("main-nav__list-child")
			$navSearch.insertAdjacentElement('beforeEnd', $navSearchForm);
			$navSearchForm.outerHTML = `<ul class="main-nav__list-child"><li class="nav_level_2_head">${$navSearchForm.outerHTML}</li></ul>`;
			$mainNav.forEach(el => {
				const level1s = Array.prototype.slice.call(el.querySelectorAll(".nav_level_1"), 0);
				level1s.forEach(elv1 => {
					if (elv1.querySelector("ul")) {
						elv1.classList.add("has-child");
						elv1.addEventListener("click", () => {
							elv1.querySelector("ul").classList.toggle("is-show");
						})
						elv1.addEventListener("mouseout", () => {
							elv1.querySelector("ul").classList.remove("is-show");
							$navBg.style.height = 0;
						})
						const $navBg = document.getElementById("main-nav_bg")
						elv1.addEventListener("mouseover", () => {
							const navHeight = elv1.querySelector(".main-nav__list-child").offsetHeight;
							// console.log(navHeight)
							$navBg.style.height = `${navHeight}px`;
						})
						const navEng = elv1.getAttribute("data-eng");
						const navJp = elv1.getAttribute("data-jp");
						// console.log(navEng)
						if (navEng !== null) {
							const headLi = document.createElement("li");
							headLi.classList.add("nav_level_2_head");
							headLi.innerHTML = `${navEng}<span class="nav-jp">${navJp}</span>`;
							// elv1.querySelector("ul").prepend(headLi);
							const elv1Ul = elv1.querySelector("ul");
							elv1Ul.insertBefore(headLi, elv1Ul.childNodes[0]);
						}
					}
				});
				const level2s = Array.prototype.slice.call(el.querySelectorAll(".nav_level_2"), 0);
				level2s.forEach(elv2 => {
					if (elv2.querySelector("ul")) {
						elv2.classList.add("has-child");
					}
				});
			});
		}
	}

	previousVerticalPos = window.pageYOffset;
	//Humberger
	const $navbarBurgers = Array.prototype.slice.call(document.querySelectorAll("button.main-nav__humberger"), 0);
	if ($navbarBurgers.length > 0) {
		$navbarBurgers.forEach(el => {
			el.addEventListener("click", () => {
				const target = el.dataset.target;
				const $target = document.getElementById(target);
				// el.classList.toggle("is-active");
				document.body.classList.toggle("is-active");
				$target.classList.toggle("is-active");
				if (el.classList.contains("is-active")) {
					el.setAttribute("aria-expanded", "true");
				} else {
					el.setAttribute("aria-expanded", "false");
				}
			})
		});
	}


	//monthly
	setMonthly();

	//weekly
	getPictureOfTheWeek();

	//遅延ロード
	const lazyLoad = Array.prototype.slice.call(document.body.querySelectorAll(".js-lazy-load"), 0);
	const options = {
		rootMargin: "0px",
		threshold: [0]
	};
	const lazyLoader = (el) => {
		el.forEach(t => {
			if (t.intersectionRatio > 0) {
				// console.log(t)
				const $t = t.target;
				const data = $t.dataset.src;
				$t.setAttribute("src", data);
				// console.log($t,data)
				isObserver.unobserve($t);
			}
		})
	}
	const isObserver = new IntersectionObserver(lazyLoader, options)
	lazyLoad.forEach(el => {
		isObserver.observe(el);
	})

	const fiAnime = Array.prototype.slice.call(document.querySelectorAll(".top_anime_fi"), 0)
	const addfiAnime = (el) => {
		el.forEach(t => {
			if (t.intersectionRatio > 0) {
				const $t = t.target;
				// console.log("t:",$t)
				$t.classList.add("top_anime_show");
				isObserver.unobserve($t);
			}
		})
	}
	const isObserverAnime = new IntersectionObserver(addfiAnime, options)
	fiAnime.forEach(el => {
		isObserverAnime.observe(el);
	});

	//
	const links = Array.prototype.slice.call(document.body.querySelectorAll("#main-nav a"), 0)
	links.forEach(el => {
		const href = el.getAttribute("href");
		const path = href.replace(`${window.location.protocol}//${window.location.host}`, "");
		const currentPath = window.location.pathname.split("/")[1];
		if (path.indexOf(currentPath) > 0 || (currentPath === "" && path === "/")) {
			el.parentNode.classList.add("stay");
		}
		// console.log(path,currentPath,path.indexOf(currentPath))
	})

	if (typeof SmoothScroll === "function") {
		const scroll = new SmoothScroll('a[href*="#"]', {
			speed: 300
		});
	}

	if (document.querySelectorAll(".top__carousel").length > 0) {
		let swipernum = 0;
		const swiper = new Swiper('.top__carousel', {
			loop: true,
			autoplay: {
				delay: 3000,
				disableOnInteraction: false,
			},
			pagination: {
				el: '.swiper-pagination',
				clickable: true,
			},
		});
		swiper.on('slideChangeTransitionEnd', function () {
			if (swiper.activeIndex === 2) {
				swipernum += 1
				if (swipernum >= 2) {
					swiper.autoplay.stop();
				}
			}
		});
	}

	//PDF open in the new window
	// const atags = Array.prototype.slice.call(document.querySelectorAll("a"),0)
	// atags.forEach(el => {
	// 	console.log(el)
	// 	const href = el.getAttribute("href")
	// 	if (href.indexOf(".pdf")>=0) {
	// 		el.setAttribute("target","_blank")
	// 	}
	// })

	//Equal heights
	const heights = Array.prototype.slice.call(document.querySelectorAll(".equal_height"), 0);
	let highest = 0;
	heights.forEach(el => {
		const curHeight = el.offsetHeight;
		highest = Math.max(highest, curHeight);
		// console.log(highest)
	})
	heights.forEach(el => {
		el.style.height = `${highest}px`;
	})

	//wrap inner
	if (document.querySelectorAll(".entry__column").length > 0) {
		const cols = Array.prototype.slice.call(document.querySelectorAll(".entry__column"), 0);
		cols.forEach(el => {
			const wrapper = document.createElement("div");
			// wrapper.classList.add("entry__column", "column")
			// el.classList.remove("entry__column", "column")
			wrapper.classList.add("entry__column");
			wrapper.classList.add("column");
			el.classList.remove("entry__column");
			el.classList.remove("column");
			el.classList.add("entry__column_inner");
			el.parentNode.insertBefore(wrapper, el);
			wrapper.appendChild(el);
		})
	}

	//Privacy Policy
	const checkedCheck = (el) => {
		const $submit = document.getElementById("submit");
		const $t = el;
		// console.log($t.checked)
		if ($t.checked) {
			$submit.disabled = false;
		} else {
			$submit.disabled = true;
		}
	}

	const $privacyCheck = document.getElementById("privacypolicy");
	if ($privacyCheck !== null) {
		checkedCheck($privacyCheck);
		if ($privacyCheck) {
			$privacyCheck.addEventListener("change", el => {
				checkedCheck(el.target);
			})
		}
	}

	// const productTitle = Array.prototype.slice.call(document.querySelectorAll(".products__card"),0)
	// productTitle.forEach(pt => {
	// 	const t=pt.getElementsByTagName("h3")[0].innerHTML
	// 	if (t.indexOf("翻訳")<0) {
	// 		const nt = t.replace("（","<br>（")
	// 		pt.getElementsByTagName("h3")[0].innerHTML = nt
	// 	}
	// })

	checkOnScroll();


	new ScrollHint('.js-table-unit-scroll-hint', {
		scrollHintIconAppendClass: 'scroll-hint-icon-white', // white-icon will appear
		applyToParents: true,
		i18n: {
			scrollable: 'スクロールできます'
		}
	});
})

//polyfill
// https://tc39.github.io/ecma262/#sec-array.prototype.findindex
if (!Array.prototype.findIndex) {
	Object.defineProperty(Array.prototype, 'findIndex', {
		value: function (predicate) {
			// 1. Let O be ? ToObject(this value).
			if (this == null) {
				throw new TypeError('"this" is null or not defined');
			}

			var o = Object(this);

			// 2. Let len be ? ToLength(? Get(O, "length")).
			var len = o.length >>> 0;

			// 3. If IsCallable(predicate) is false, throw a TypeError exception.
			if (typeof predicate !== 'function') {
				throw new TypeError('predicate must be a function');
			}

			// 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
			var thisArg = arguments[1];

			// 5. Let k be 0.
			var k = 0;

			// 6. Repeat, while k < len
			while (k < len) {
				// a. Let Pk be ! ToString(k).
				// b. Let kValue be ? Get(O, Pk).
				// c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
				// d. If testResult is true, return k.
				var kValue = o[k];
				if (predicate.call(thisArg, kValue, k, o)) {
					return k;
				}
				// e. Increase k by 1.
				k++;
			}

			// 7. Return -1.
			return -1;
		},
		configurable: true,
		writable: true
	});
}
